const SvgCorruption = (props) => (
  <svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-1-1h18v18H-1z" />
      <path
        d="M.5 4v11.5H12l-.5-.5a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5L.5 4z"
        stroke="currentColor"
      />
      <path
        d="M16 8.84V11a1 1 0 0 1-1 1h-1v-1h1V8.84h1zm0-1.5h-1V4.66h1v2.68zm0-4.18h-1V1h-2.16V0H15a1 1 0 0 1 1 1v2.16zM11.34 0v1H8.66V0h2.68zM7.16 0v1H5v1H4V1a1 1 0 0 1 1-1h2.16z"
        fill="currentColor"
      />
      <path
        d="M5.986 5L5 5.986 7.014 8 5 10.014l.986.986L8 8.986 10.014 11l.986-.986L8.986 8 11 5.986 10.014 5 8 7.014"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgCorruption
